export const VoucherTypes = { Lunch: 'lounas', Recreational: 'virike' };

export const getVoucherTypeKey = voucherType =>
  Object.keys(VoucherTypes).find(
    key => VoucherTypes[key] === (voucherType || '').toLowerCase()
  );
